import React from 'react';
import withVirtualScroll from '../../../../dispatcher/hoc/withVirtualScroll';
import { PureComponent } from '../../../../dispatcher/modules';
import { PuzzleDropDownList } from '../../../index';
import * as _ from 'lodash';
import {
  PUZZLE_REMOTE_DROP_DOWN_LIST_PROPS
} from './Types';
import uuid from 'uuid-random';

/**
 * Remote data and filter dropdown list
 */
class PuzzleRemoteDropDownList extends PureComponent<PUZZLE_REMOTE_DROP_DOWN_LIST_PROPS> {
  moduleId = uuid();

  /**
   * Call external parseData function
   * @param data
   */
  parseData = (data: any) => {
    if (_.isFunction(this.props.parseData)) {
      data = this.props.parseData(data);
    }

    return data;
  };

  /**
   * Set data is function from virtual scroll component
   * preferably it should not be changed
   * @param data
   */
  setData = (data: any) => {
    _.get(this, 'props.setData') && this.props.setData(data);
  };

  renderBody() {
    return (
      <PuzzleDropDownList
        {...this.props}
      />
    );
  }
}

export default withVirtualScroll(PuzzleRemoteDropDownList);
